import { AppConfig } from "../app/Services/config";

const GUICHET_CONFIG: AppConfig = {
  //apiEndpoint: 'https://api.stggui.wissalstore.com',
  apiEndpoint: "https://api.devgui.wissalstore.com/api/v1",
  // apiEndpoint: "http://localhost:8081/api/v1",
  title: "Guichet endpoint",
  clientId: "wissalsys-ecommerce-guichet",
  secret: "XY7kmzoNzl100",
};

export const environment = {
  production: false,
  apiEndpointConfig: GUICHET_CONFIG,
};
